const tools = {
	// 日期格式化，示例：tools.formatDate('2018-10-24', 'yyyy-MM-dd hh:mm:ss')
	formatDate(d:any, fmt?:any) {
		if(!d) return '';
		if(typeof d === 'string') {
			// now时返回当前时间
			if(d == 'now') {
				d = new Date();
			}else{
				d = new Date(d);
			}
		}
		if(!fmt) fmt = 'yyyy-MM-dd';
		let o:any = { 
	        "M+" : d.getMonth() + 1,                 //月份 
	        "d+" : d.getDate(),                    //日 
	        "h+" : d.getHours(),                   //小时 
	        "m+" : d.getMinutes(),                 //分 
	        "s+" : d.getSeconds(),                 //秒 
	        "q+" : Math.floor((d.getMonth() + 3) / 3), //季度 
	        "S"  : d.getMilliseconds()             //毫秒 
	    }; 
	    if(/(y+)/.test(fmt)) {
	        fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length)); 
	    }
	    for(let k in o) {
	        if(new RegExp("("+ k +")").test(fmt)){
	            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	        }
	    }
	    return fmt;
	}
}

export default tools;
